import { store } from "../../store/store";
export function showToaster(title, color, icon, desc, image) {
  store.dispatch({
    type: "toaster/addToaster",
    payload: {
      id: new Date().getTime(),
      title,
      color,
      icon,
      desc,
      image,
    },
  });
}
